import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './MojeDokumenty.css';
import { Row, Col, Pagination, Table, Tooltip, OverlayTrigger } from 'react-bootstrap';
import fetch from '../../core/fetch';
import waiting from './waiting-wheel-300x300.gif';
import GrayPanel from '../../components/GrayPanel';
import Link from '../../components/Link';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage, statusMap, getTokenFromCookie } from '../../components/utils/utils';
import ModalAlert from '../eservices/ModalAlert';
import v from '../eservices/validators';


const errorSpanStyle = {
  color: 'red',
  fontSize: '10px',
};

const rowStyle = {
  display: 'flex',
  alignItems: 'center'
};

const operator_map = {
  Przed: 'lt',
  Po: 'gt',
  Równe: 'equal',
};

const orderingDict = {
  'Krótka nazwa A-Z': 'shortName',
  'Krótka nazwa Z-A': 'shortName desc',
  'Data - od najnowszej': 'date desc',
  'Data - od najstarszej': 'date',
}

const col_header_map = {
  shortName: 'Krótka nazwa',
  isSigned: 'Czy podpisany',
  timeStart: 'Data',
  status: 'Status',
  paymentStatus: 'Płatność',
  cost: 'Koszt [zł]',
  teryt: 'Jednostka',
  parcels: 'Działki',
  uppDownload: 'UPP',
  actions: 'Wniosek'
};

const visible_columns = [
  'shortName',
  'isSigned',
  'timeStart',
  'status',
  'paymentStatus',
  'cost',
  'teryt',
  'parcels',
  'uppDownload',
  'actions',
];

const visible_draft_columns = [
  'fk_service',
  'updated_at',
  'fk_districtID',
  'parcels',
  'actions',
];

const col_header_draft_map = {
  fk_service: 'Krótka nazwa',
  fk_districtID: 'Jednostka',
  updated_at: 'Data',
  parcels: 'Działki',
  actions: 'Akcje',
};

class MojeDokumenty extends React.Component {
  state = {
    apply_button_disabled: true,
    per_page: 25,
    docs_page_counter: 25,
    page: 1,
    info_request: null,
    filters: null,
    date: `01-01-${new Date().getFullYear()}`,
    format: 'YYYY-MM-DD',
    inputFormat: 'DD/MM/YYYY',
    mode: 'date',
    focused: true,
    operator: 'gt',
    status: '',
    paymentStatus: '',
    selected_services: [],
    services_options: [],
    selected_districts: [],
    districts_options: [],
    pages: null,
    user_claims: null,
    user_drafts: null,
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    orderingValue: 'Data - od najnowszej',
    orderingOption: 'date desc',
    paymentMethods: [],
    isMounted: false,
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
  };

  validators = {
    date: [v.CheckDate],
  };

  componentDidMount() {
    let options = [];
    const urzedy = [];
    for (const v of Object.keys(this.props.districts)) {
      const elem = { label: this.props.districts[v].name, value: this.props.districts[v].teryt };
      urzedy.push(elem);
    }

    const url = `${process.env.API_URL}/eservices/allservices/`;
    fetch(url)
      .then(r => r.json())
      .then(resp => {
        options = resp;
        this.setState({ districts_options: urzedy, services_options: options }, () =>
          this.fetch_info_page(),
    );
      });

    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
      minHeight: '80vh',
      backgroundColor: null,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
        minHeight: '80vh',
      };
    }
    this.setState({ colors, sourceStyle, style });

    const paymentMethodsUrl = `${process.env.API_URL}/eservices/getDistrictPaymentMethods`;
    fetch(paymentMethodsUrl)
      .then(r => r.json())
      .then(resp => {
        this.setState({ paymentMethods: resp });
      });
  }

  validateBeforeFetch = () => {
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      return this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
    }

    this.fetch_info_page();
  }

  fetch_info_page = () => {
    this.setState({ isMounted: false }, () => {
      let filtr = '';
      if (this.state.date) filtr += `&date=${this.state.date}&operator=${this.state.operator}`;
      if (this.state.status) filtr += `&status=${this.state.status}`;
      if (this.state.paymentStatus) filtr += `&paymentStatus=${this.state.paymentStatus}`;
      if (this.state.selected_districts.length) {
        filtr += `&teryt=[${this.state.selected_districts.reduce((prev, cur, i) => {
          if (i !== 0) {
            return `${prev}, ${cur.value}`;
          }
          return prev + cur.value;
        }, '')}]`;
      }
      if (this.state.selected_services.length) {
        filtr += `&services=[${this.state.selected_services.reduce((prev, cur, i) => {
          if (i !== 0) {
            return `${prev}, ${cur.value}`;
          }
          return prev + cur.value;
        }, '')}]`;
      }
  
      filtr += `&ordering=${this.state.orderingOption}`;
  
      let url = `${process.env.API_URL}/user/documents/${
        this.props.userData.ID
      }?expanded=1&per_page=${this.state.per_page}&page=${this.state.page}`;
      if (filtr) url += filtr;
      fetch(url)
        .then(r => r.json())
        .then(resp => {
          this.setState({ ...resp });
        });


      // Drafts list requires the owner's token and returns { data, pages }
      // with rows already resolved (district / service objects, parcels).
      let draftsurl = `${process.env.API_URL}/user/drafts/${
        this.props.userData.ID
      }?per_page=${this.state.per_page}&page=${this.state.page}`;
      if (filtr) draftsurl += filtr;
      fetch(draftsurl, {
        headers: { Authorization: `Bearer ${getTokenFromCookie()}` },
      })
        .then(r => r.json())
        .then(resp => {
          this.setState({ user_drafts: resp.data, isMounted: true });
        });
    })
  };

  reset_filters = () => {
    this.setState({
      date: `01-01-${new Date().getFullYear()}`,
      operator: 'gt',
      status: '',
      paymentStatus: '',
      selected_districts: [],
      selected_services: [],
      orderingOption: 'date desc',
      orderingValue: 'Data - od najnowszej',
      per_page: 25,
      page: 1,
    }, () => this.fetch_info_page())
  }

  getDateFromString = date => {
    let textDate = 'brak informacji';
    if (date) {
      const asDate = new Date(date);
      
      let day = asDate.getDate();
      if (day < 10) day = `0${day}`;

      let month = asDate.getMonth() + 1;
      if (month < 10) month = `0${month}`;

      const year = asDate.getFullYear();

      let hours = asDate.getHours();
      if (hours < 10) hours = `0${hours}`;

      let minutes = asDate.getMinutes();
      if (minutes < 10) minutes = `0${minutes}`;

      textDate = `${day}.${month}.${year} ${hours}:${minutes}`;
    }
    return textDate;
  };

  logChange = e => this.setState({ selected_services: e });

  orderingChange = (e) => {
    const orderingOption = e.target.value;
    this.setState({ orderingOption: orderingDict[orderingOption], orderingValue: orderingOption });
  };

  logChangeDistrict = e => this.setState({ selected_districts: e });

  applyButton = page => this.setState({ apply_button_disabled: true, docs_page_counter: this.state.per_page }, () => this.setPage(page));

  setPage = page => this.setState({ page }, () => this.fetch_info_page());

  changeOperator = e =>
    this.setState({ operator: e.target.value });
  changeStatus = e => this.setState({ status: e.target.value });
  changePaymentStatus = e => this.setState({ paymentStatus: e.target.value });

  onHide = () => this.setState({ showError: false });

  onChange = (e) => {
    const name = e.target.name;
    this.setState(
      {
        [name]: e.target.value,
      },
      () => this.validate(name),
    );
  };

  validate = (field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  validateField = (field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  deleteDraft = (draftId) => {
    const url = `${process.env.API_URL}/drafts/delete/${draftId}`;

    fetch(url, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${getTokenFromCookie()}` },
    })
      .then(resp => {
        if (resp.status === 200) {
          return this.setState({
            errorText: 'Wersja robocza wniosku została usunięta.',
            errorTitle: 'Sukces',
            showError: true,
          }, () => this.fetch_info_page());
        } else {
          return this.setState({
            errorText: 'Wystąpił błąd podczas usuwania wersji roboczej wniosku.',
            errorTitle: 'Błąd usuwania',
            showError: true,
          });
        }
      })
      .catch(() => {
        return this.setState({
          errorText: 'Wystąpił błąd podczas usuwania wersji roboczej wniosku.',
          errorTitle: 'Błąd usuwania',
          showError: true,
        });
      });
  }

  renderCol = (v, i, data) => {
    const buttonStyle = {
      padding: '2px 2px',
      marginLeft: '0px',
      color: layoutColorStyle[this.state.colors].color,
      backgroundColor: layoutColorStyle[this.state.colors].backgroundColor,
    };
    if (v === 'shortName') {
      const service = this.props.eservices ? this.props.eservices[data[v]] : null;
      return service ? (
        <td key={`${v}${i}`}>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="tooltip">
                <strong>Kliknij aby przejść do podsumowania</strong>
              </Tooltip>
            }
          >
            <Link to={`/paymentStatus/${data.jobId}`}>{service.title}</Link>
            {/* <a href="#">{service.title}</a> */}
          </OverlayTrigger>
        </td>
      ) : (
        <td key={`${v}${i}`}>{data[v]}</td>
      );
    }
    if (v === 'isSigned') {
      return <td key={`${v}${i}`}>{data[v] ? 'TAK' : 'NIE'}</td>;
    }
    if (v === 'timeStart') {
      return <td key={i}>{this.getDateFromString(data[v])}</td>;
    }
    if (v === 'status') {
      if (data[v] === 'finished') {
        return <td key={`${v}${i}`}>zakończony</td>;
      }
      return <td key={`${v}${i}`}><a type="submit-lg" className="btn btn-default" target='_blank' href={`${window.location.origin}/eservices/${data.continuation_point}/${data.jobId}`} style={buttonStyle}>Kontynuuj</a></td>;
      
    }
    if (v === 'paymentStatus') {
      const paymentMethod = this.state.paymentMethods[data.paymentMethod];
      if (paymentMethod) {
        if (paymentMethod.label === 'Przelewem' || paymentMethod.label === 'W kasie urzędu' || paymentMethod.label === 'W opłatomacie urzędu') {
          return <td key={`${v}${i}`}>{paymentMethod.label}</td>;
        }

        return <td key={`${v}${i}`}>{statusMap[data[v]]}</td>;
      }

      return data['requires_payment'] ? <td key={`${v}${i}`}>Nie wybrano sposobu płatności</td> : <td key={`${v}${i}`}>Niewymagana</td>;
    }
    if (v === 'teryt') {
      const district = _.find(
        this.props.districts,
        dist => dist.teryt.toString() === data[v],
      );
      if (district) {
        return <td key={`${v}${i}`}>{district.name}</td>;
      }
      return <td key={`${v}${i}`}>{data[v]}</td>;
    }
    if (v === 'cost') {
      return <td key={`${v}${i}`}>{data[v].toFixed(2)}</td>;
    }
    if (v === 'parcels') {
      return <td key={`${v}${i}`}>{data[v].length}</td>;
    }
    if (v === 'uppDownload') {
      if (data.hasUPP) {
        return <td key={`${v}${i}`}><a type="submit-lg" className="btn btn-default" target='_blank' href={`${process.env.API_URL}/eservices/getUPP/${data.jobId}`} style={buttonStyle}>Pobierz</a></td>;
      }
      return <td key={`${v}${i}`}>-</td>;
    }
    if (v === 'actions') {
      return <td key={`${v}${i}`}><a type="submit-lg" className="btn btn-default" href={`${process.env.API_URL}/eservices/getJobDocs/${data.jobId}`} style={buttonStyle}>Pobierz</a></td>;
    }
  };

  renderDraftCol = (v, i, data, district, shortName) => {
    const buttonStyle = {
      padding: '2px 2px',
      marginLeft: '0px',
      color: layoutColorStyle[this.state.colors].color,
      backgroundColor: layoutColorStyle[this.state.colors].backgroundColor,
    };
    if (v === 'fk_service') {
      return <td key={`${v}${i}`}>{shortName}</td>;
    }
    if (v === 'fk_districtID') {
      if (data.district && data.district.name) {
        return <td key={`${v}${i}`}>{data.district.name}</td>;
      }
      return <td key={`${v}${i}`}>nie znaleziono jednostki</td>;
    }
    if (v === 'updated_at') {
      return <td key={i}>{this.getDateFromString(data[v])}</td>;
    }
    if (v === 'parcels') {
      return <td key={`${v}${i}`}>{data.parcels ? data.parcels.length : 0}</td>;
    }
    if (v === 'actions') {
      return (
        <td key={`${v}${i}`}>
          {district && shortName ? <a type="submit-lg" className="btn btn-default" target='_blank' href={`${window.location.origin}/eservices?district=${district.teryt}&serviceType=${shortName}`} style={buttonStyle}>Wróć do formularza</a> : null}
          <button className="btn btn-default" style={{ ...buttonStyle, marginLeft: '10px' }} onClick={() => this.deleteDraft(data.id)}>Usuń wersję roboczą</button>
        </td>
      );
    }
  };

  renderRow = (v, i) => {
    const number = i + 1 + (this.state.docs_page_counter * (this.state.page - 1));
    return (
      <tr key={i}>
        <td>{number}</td>
        {visible_columns.map((col, col_index) => this.renderCol(col, col_index, v))}
      </tr>
    );
  };

  renderDraftRow = (v, i) => {
    const number = i + 1;
    // The row comes resolved from the backend (district / service objects);
    // props.districts is only needed for the TERYT used in the form link.
    const district = _.find(
      this.props.districts,
      dist => dist.appID === (v.district && v.district.id),
    );
    const shortName = (v.service && v.service.shortName) || 'nie znaleziono usługi';

    return (
      <tr key={i}>
        <td>{number}</td>
        {visible_draft_columns.map((col, col_index) => this.renderDraftCol(col, col_index, v, district, shortName))}
      </tr>
    );
  };

  renderPagination = () => {
    const pageCount = this.state.pages.pages;
    const current = this.state.page;

    let start = 1;
    let end = pageCount;
    const diff = 5;

    if (pageCount >= 2 * diff) {
      if (current + diff >= pageCount) {
        start = pageCount - 2 * diff + 1;
        end += 1;
      }
      if (current >= diff && current + diff <= pageCount) {
        start = current - diff + 1;
        end = current + diff;
      }
      if (current < diff) {
        start = 1;
        end = 1 + 2 * diff;
      }
    } else {
      end = pageCount + 1;
    }
    if (start === 1 && end === 1) end += 1;

    return (
      <Pagination>
        <Pagination.First
          disabled={this.state.page === 1}
          onClick={() => this.setPage(1)}
        />
        <Pagination.Prev
          disabled={this.state.page === 1}
          onClick={() => this.state.page !== 1 ? this.setPage(this.state.page - 1) : null}
        />
        {_.range(start, end).map((v, i) => (
          <Pagination.Item key={i} onClick={() => this.setPage(v)} active={v === this.state.page}>
            {v}
          </Pagination.Item>
        ))}
        <Pagination.Next
          disabled={this.state.page === pageCount}
          onClick={() => this.state.page !== pageCount ? this.setPage(this.state.page + 1) : null}
        />
        <Pagination.Last
          disabled={this.state.page === pageCount}
          onClick={() => this.setPage(pageCount)}
        />
      </Pagination>
    );
  };

  render() {
    const { color, backgroundColor } = this.state.style;
    return this.state.isMounted ? (
      <div className={s.mdContainer} style={this.state.style}>
        {this.state.colors !== 'normal' && (
          <style>
            {`
              /* Kontener całego dropdowna */
              .Select-menu-outer {
                background-color: ${backgroundColor};
              }

              /* Wewnętrzny kontener z listą opcji */
              .Select-menu {
                background-color: ${backgroundColor};
              }

              /* Pojedyncze opcje w dropdownie */
              .Select-option {
                background-color: ${backgroundColor};
                color: ${color};
              }

              /* Opcja pod myszką (hover / focus) - odwrócone kolory */
              .Select-option.is-focused {
                background-color: ${color};
                color: ${backgroundColor};
              }
            `}
          </style>
        )}

        <style>
          {`.pagination > .disabled > span {
              color: ${backgroundColor || 'black'};
            }
          `}
        </style>
        <Row>
          <Col xs={12}>
            <h2 style={{ fontSize: '24px' }}>
              Zastosuj filtry aby wyszukać sprawę
            </h2>
          </Col>
        </Row>
        <Row style={rowStyle}>
          <Col xs={4}>
            <h3
              style={{ fontSize: '18px', marginTop: '10px' }}
              id='moje-dokumenty-data-wygenerowania'
            >
              Data wygenerowania
            </h3>
          </Col>
          <Col xs={2}>
            <select
              className="form-control needsclick"
              aria-labelledby='moje-dokumenty-data-wygenerowania'
              value={this.state.operator}
              onChange={this.changeOperator}
              style={{ width: '100%', color: this.state.style.color, backgroundColor: this.state.style.backgroundColor }}
            >
              {Object.keys(operator_map).map((v, i) => (
                <option key={i} value={operator_map[v]}>
                  {v}
                </option>
              ))}
            </select>
          </Col>
          <Col xs={2}>
            <h3
              style={{ fontSize: '18px' }}
              id='moje-dokumenty-label'
            >
              Wprowadź datę
            </h3>
          </Col>
          <Col xs={3}>
            <input
              className="form-control"
              aria-labelledby='moje-dokumenty-label'
              value={this.state.date}
              name="date"
              onChange={e => this.onChange(e)}
              style={{
                borderColor:
                  Object.keys(this.state.errors).indexOf("date") > -1 &&
                  this.state.errors["date"] !== null &&
                  this.state.errors["date"].length > 0
                    ? 'red'
                    : '#ccc',
                color: color,
                backgroundColor: backgroundColor,
              }}
            />
            {Object.keys(this.state.errors).indexOf("date") > -1 &&
                this.state.errors["date"] !== null &&
                this.state.errors["date"].length > 0
                  ? this.state.errors["date"].map((val, index) => (
                    <span key={index} style={errorSpanStyle}>
                      {val}
                    </span>
                    ))
            : null}
          </Col>
        </Row>
        <Row style={rowStyle}>
          <Col xs={4}>
            <h3
              style={{ fontSize: '18px' }}
              id='moje-dokumenty-status'
            >
              Status
            </h3>
          </Col>
          <Col xs={3}>
            <select
              className="form-control needsclick"
              aria-labelledby='moje-dokumenty-status'
              value={this.state.status}
              onChange={this.changeStatus}
              style={{ color: this.state.style.color, backgroundColor: this.state.style.backgroundColor }}
            >
              <option />
              <option>niedokończony</option>
              <option>zakończony</option>
            </select>
          </Col>
        </Row>
        <Row style={rowStyle}>
          <Col xs={4}>
            <h3
              style={{ fontSize: '18px' }}
              id='moje-dokumenty-status-pl'
            >
              Płatność
            </h3>
          </Col>
          <Col xs={3}>
            <select
              className="form-control needsclick"
              aria-labelledby='moje-dokumenty-status-pl'
              value={this.state.paymentStatus}
              onChange={this.changePaymentStatus}
              style={{ color: this.state.style.color, backgroundColor: this.state.style.backgroundColor }}
            >
              <option />
              <option>Niewymagana</option>
              <option>Nie wybrano sposobu płatności</option>
              <option>Przelewem</option>
              <option>W kasie urzędu</option>
              <option>Płatność elektroniczna - oczekuje</option>
              <option>Płatność elektroniczna - opłacono</option>
              <option>Płatność elektroniczna - niedokończona</option>
              <option>Płatność elektroniczna - nieudana</option>
            </select>
          </Col>
        </Row>
        <Row style={rowStyle}>
          <Col xs={4}>
            <h3
              style={{ fontSize: '18px' }}
              id='moje-dokumenty-jednostka'
            >
              Jednostka Administracyjna
            </h3>
          </Col>
          <Col xs={8}>
            <Select
              placeholder={<p style={{ color: this.state.style.color }}>Wybierz jednostkę</p>}
              aria-labelledby='moje-dokumenty-jednostka'
              multi
              rows={40}
              name="form-field-name"
              value={this.state.selected_districts}
              options={this.state.districts_options}
              clearable={false}
              onChange={this.logChangeDistrict}
              onBlur={event => event.preventDefault()}
              optionClassName="needsclick"
              blurInputOnSelect={false}
              style={{ color: this.state.style.color, backgroundColor: this.state.style.backgroundColor }}
            />
          </Col>
        </Row>
        <Row style={rowStyle}>
          <Col xs={4}>
            <h3
              style={{ fontSize: '18px' }}
              id='moje-dokumenty-uslugi'
            >
              Usługi
            </h3>
          </Col>
          <Col xs={8}>
            <Select
              placeholder={<p style={{ color: this.state.style.color }}>Wybierz usługi</p>}
              aria-labelledby='moje-dokumenty-uslugi'
              multi
              rows={40}
              name="form-field-name"
              value={this.state.selected_services}
              options={this.state.services_options}
              clearable={false}
              onChange={this.logChange}
              onBlur={event => event.preventDefault()}
              optionClassName="needsclick"
              blurInputOnSelect={false}
              style={{ color: this.state.style.color, backgroundColor: this.state.style.backgroundColor }}
            />
          </Col>
        </Row>
        <Row style={rowStyle}>
          <Col xs={4}>
            <h3
              style={{ fontSize: '18px' }}
              id='moje-dokumenty-sortuj'
            >
              Sortuj według
            </h3>
          </Col>
          <Col xs={3}>
            <select
              className="form-control needsclick"
              aria-labelledby='moje-dokumenty-sortuj'
              value={this.state.orderingValue}
              onChange={this.orderingChange}
              style={{ color: this.state.style.color, backgroundColor: this.state.style.backgroundColor }}
            >
              <option>Krótka nazwa A-Z</option>
              <option>Krótka nazwa Z-A</option>
              <option>Data - od najnowszej</option>
              <option>Data - od najstarszej</option>
            </select>
          </Col>
        </Row>
        <Row style={{ ...rowStyle, marginTop: '20px'}}>
          <Col xs={9}></Col>
          <Col xs={2}>
            <button
              onClick={() => this.reset_filters()}
              className="btn btn-secondary pull-right"
              style={{ color: 'white' }}
            >
              Wyczyść filtry
            </button>
          </Col>
          <Col xs={1}>
            <button
              onClick={() => this.validateBeforeFetch()}
              className="btn btn-primary"
            >
              Filtruj
            </button>
          </Col>

        </Row>

        {this.state.user_drafts && this.state.user_drafts.length ? (
          <Row style={{ marginTop: '20px' }}>
            <Col xs={12}>
              <p><b>FORMULARZE ROBOCZE</b></p>
              <Table condensed>
                <thead>
                  <tr>
                    <th>#</th>
                    {visible_draft_columns.map((v, i) => {
                      return <th key={i}>{col_header_draft_map[v]}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>{this.state.user_drafts.map((v, i) => this.renderDraftRow(v, i))}</tbody>
              </Table>
            </Col>
          </Row>
        ) : null}

        {this.state.user_claims ? (
          <Row style={{ marginTop: '20px' }}>
            <Col xs={12}>
              <p><b>WNIOSKI PROCEDOWANE</b></p>
              <Table condensed>
                <thead>
                  <tr>
                    <th>#</th>
                    {visible_columns.map((v, i) => {
                      return <th key={i}>{col_header_map[v]}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>{this.state.user_claims.length ? this.state.user_claims.map((v, i) => this.renderRow(v, i))
                : <tr>
                    <td colSpan={visible_columns.length + 1} style={{ textAlign: 'center', fontWeight: 'bold' }}>brak wniosków spełniających podane kryteria</td>
                  </tr>
                }
                </tbody>
              </Table>
            </Col>
          </Row>
        ) : null}
        {this.state.pages ? (
          <Row style={{ ...rowStyle, textAlign: 'center'}}>
            <Col xs={1}>
              <span id='moje-dokumenty-na-stronie'>Na stronie: </span>
            </Col>
            <Col xs={1}>
              <input
                className="form-control"
                aria-labelledby='moje-dokumenty-na-stronie'
                value={this.state.per_page}
                onChange={e =>
                  this.setState({ per_page: e.target.value, apply_button_disabled: false })
                }
              />
            </Col>
            <Col xs={1}>
              <button
                type="submit-lg"
                className="btn btn-default"
                // disabled={this.state.apply_button_disabled}
                style={{ float: 'right', marginRight: '15px' }}
                onClick={() => this.applyButton(1)}
              >
                Zastosuj
              </button>
            </Col>
            <Col xs={8}>{this.renderPagination()}</Col>
            <Col xs={1}>
              <div>
                {this.state.page}/{this.state.pages.pages}
              </div>
            </Col>
          </Row>
        ) : null}
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </div>
    ) : (
      <GrayPanel
        title="Trwa ładowanie zawartości..."
        bodyStyle={{ textAlign: 'center', marginTop: '100px', marginBottom: '100px' }}
      >
        <img alt="Loader" src={waiting} />
      </GrayPanel>
    );
  }
}

const mapState = state => ({
  username: state.user ? state.user.username : '',
  districts: state.district.districts,
  eservices: state.eservices.eservices
});

export default withStyles(s)(connect(mapState)(MojeDokumenty));



// WEBPACK FOOTER //
// src/routes/mojeDokumenty/MojeDokumenty.js